import {
    withGoogleMap,
    GoogleMap,
    Marker,
    OverlayView
} from 'react-google-maps';
import LocationModal from './LocationModal.js';
import FilterModal from './FilterModal.js';
import SearchModal from './SearchModal.js';
import { Glyphicon } from 'react-bootstrap';
import React, { Component } from 'react';
import update from 'immutability-helper';
import CreditsModal from './CreditsModal.js';

var jsonData;
var shouldPan = false;

const InitialMap = withGoogleMap(props=> {

    const locButtonClick = coords => {
        props.changeCenter(coords);
        props.closeLocNavBar();
    }

    // toggles Locations nav bar
    const toggleNavBar = () => {
        if (document.getElementById("dropdown-content").style.display === "none") {
            document.getElementById("dropdown-content").style.display = "block";
        }
        else {
            document.getElementById("dropdown-content").style.display = "none";
        }
    }

    // hides Locations nav bar if it's open
    const hideNavBar = () => {
        if (document.getElementById("dropdown-content").style.display === "block") {
            document.getElementById("dropdown-content").style.display = "none";
        }
    }

    return (
        <div>
            <div className="topBar">
                <div className="topBarImg" alt="Michigan Daily Logo"></div>
                <CreditsModal isCredits={props.isCredits} hideNavBar={hideNavBar} giveClass="creditsButton" />
                <SearchModal isSearch={props.isSearch} changeCenter={props.changeCenter} markers={props.markers} hideNavBar={hideNavBar}></SearchModal>
                <div className="locButtonDiv">
                    <FilterModal hideNavBar={hideNavBar} markers={props.markers} isFilter={props.isFilter} setVisibility={props.setVisibility}></FilterModal>
                    <div className="dropdown">
                        <div className="locNavButton" onClick={toggleNavBar}>Locations <Glyphicon glyph="map-marker" style={{color: "red"}}/></div>
                        <div id="dropdown-content" style={{display:"none"}}>
                            <div onClick={() => locButtonClick({lat: 42.277, lng: -83.738})}>Central</div>
                            <div onClick={() => locButtonClick({lat: 42.28, lng: -83.7483398})}>Downtown</div>
                            <div onClick={() => locButtonClick({lat: 42.280178, lng: -83.732632})}>Hill</div>
                            <div onClick={() => locButtonClick({lat: 42.283416, lng: -83.746258})}>Kerrytown</div>
                            <div onClick={() => locButtonClick({lat: 42.292068, lng: -83.715938})}>North</div>
                            <div onClick={() => locButtonClick({lat: 42.268127, lng: -83.745679})}>South</div>
                            <CreditsModal isCredits={props.isCredits} hideNavBar={hideNavBar} giveClass="creditsNavBar" />
                        </div>
                    </div>
                    <div className="locButton" onClick={() => props.changeCenter({lat: 42.268127, lng: -83.745679})}>South</div>
                    <div className="locButton" onClick={() => props.changeCenter({lat: 42.292068, lng: -83.715938})}>North</div>
                    <div className="locButton" onClick={() => props.changeCenter({lat: 42.283416, lng: -83.746258})}>Kerrytown</div>
                    <div className="locButton" onClick={() => props.changeCenter({lat: 42.280178, lng: -83.732632})}>Hill</div>
                    <div className="locButton" onClick={() => props.changeCenter({lat: 42.28, lng: -83.7483398})}>Downtown</div>
                    <div className="locButton" onClick={() => props.changeCenter({lat: 42.277, lng: -83.738})}>Central</div>
                </div>

            </div>
            <GoogleMap
                ref={(map) => { if (map && shouldPan) {
                    map.panTo(props.center);
                    shouldPan = false;
                }
            }}
            zoom={props.zoom}
            onClick={hideNavBar}
            defaultCenter={{lat: 42.277, lng: -83.738}}
            defaultOptions={{styles:
                [
                    {
                        featureType: 'landscape',
                        "elementType": "labels.text",
                        stylers: [{visibility: 'off'}]
                    },
                    {
                        featureType: 'poi',
                        "elementType": "labels.text",
                        stylers: [{visibility: 'off'}]
                    },
                    {
                        featureType: 'landscape',
                        "elementType": "labels.icon",
                        stylers: [{visibility: 'off'}]
                    },
                    {
                        featureType: 'poi',
                        "elementType": "labels.icon",
                        stylers: [{visibility: 'off'}]
                    },
                    {
                        featureType: 'transit',
                        elementType: 'labels.icon',
                        stylers: [{visibility: 'off'}]
                    }
                ],
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false
            }

        }
        >
            {
                Object.keys(props.markers).map(function(marker, index) {
                    jsonData = require('./json/' + marker + '.json');

                    return (
                        <Marker
                            key={index}
                            position={jsonData.position}
                            defaultAnimation={2}
                            icon={{url: jsonData.catImage, scaledSize: {width: 22, height: 26}}}
                            visible={props.markers[marker].isVisible}
                            onClick={() => props.onMarkerClick(marker)}
                            onMouseOver={() => props.onMarkerHover(marker)}
                            onMouseOut={() => props.onMarkerMouseout(marker)}
                            >
                                {props.markers[marker].showInfo ? <LocationModal showModal={props.markers[marker].showInfo} close={() => props.onMarkerClose(marker)} loc={marker} markers={props.markers} setArticlesLoaded={props.setArticlesLoaded} /> : null}

                                {props.markers[marker].showTooltip && (

                                    <OverlayView
                                        position={jsonData.position}
                                        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                                        >
                                            <div className="overlayTooltip">
                                                <div className="tooltipText">{jsonData.name}</div>
                                                <div className="tailShadow"></div>
                                                <div className="tail1"></div>
                                                <div className="tail2"></div>
                                            </div>
                                        </OverlayView>
                                    )}
                                </Marker>
                            );
                        })
                    }
                </GoogleMap>
            </div>
        );
    });

    export default class MapContainer extends Component {
        constructor(props) {
            super(props);

            this.state = {
                center: {lat: 42.277, lng: -83.738},
                zoom: 16,
                curPage: "",
                isFilter: false,
                isCredits: false,
                isSearch: false,
                markers: {
                    "banditos" : {
                        name: "Bandito's",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "bdsmongoliangrill" : {
                        name: "bd's Mongolian Grill",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "blackpearl" : {
                        name: "Black Pearl",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "bluenile":{
                        name: "Blue Nile",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "bluetractor":{
                        name: "Blue Tractor",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "cafezola":{
                        name: "Cafe Zola",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "conoroneills":{
                        name: "Conor O'Neill's",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, entertainment: 1, nightlife: 1}
                    },
                    "cafefelix":{
                        name: "Cafe Felix",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "fritabatidos":{
                        name: "Frita Batidos",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 2,
                        totalMisc: 2,
                        categories: {location: 1, fooddrink: 1, restaurant: 1, datespot: 1, bestofaa: 1}
                    },
                    "blimpyburger":{
                        name: "Blimpy Burger",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "ahmos":{
                        name: "Ahmos",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "amers":{
                        name: "Amer's",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "agave":{
                        name: "Agave",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "angelos":{
                        name: "Angelo's",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, fooddrink: 1, restaurant: 1, bestofaa: 1}
                    },
                    "buffalowildwings":{
                        name: "Buffalo Wild Wings",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "cardamom":{
                        name: "Cardamom",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, fooddrink: 1, restaurant: 1, bestofaa: 1}
                    },
                    "fleetwooddiner":{
                        name: "Fleetwood Diner",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, fooddrink: 1, restaurant: 1, bestofaa: 1}
                    },
                    "gandydancer":{
                        name: "Gandy Dancer",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "grange":{
                        name: "Grange",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "gratzi":{
                        name: "Gratzi",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "grizzlypeak":{
                        name: "Grizzly Peak",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "heidelberg":{
                        name: "Heidelberg",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "hunterhouse":{
                        name: "Hunter House",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "bellydeli":{
                        name: "Belly Deli",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "maniosteria":{
                        name: "Mani Osteria",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, fooddrink: 1, restaurant: 1, bestofaa: 1}
                    },
                    "marneethai":{
                        name: "Marnee Thai",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "melange":{
                        name: "Melange",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "nagomisushi":{
                        name: "Nagomi Sushi",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "neopapalis":{
                        name: "Neopapalis",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "nothaisouthu":{
                        name: "No Thai (South U)",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, fooddrink: 1, restaurant: 1, bestofaa: 1}
                    },
                    "nothai4thave":{
                        name: "No Thai (4th Ave)",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, fooddrink: 1, restaurant: 1, bestofaa: 1}
                    },
                    "pacificrim":{
                        name: "Pacific Rim",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "palio":{
                        name: "Palio",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "pancheros":{
                        name: "Pancheros",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "pieology":{
                        name: "Pieology",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "pizzabobs":{
                        name: "Pizza Bob's",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "pizzahouse":{
                        name: "Pizza House",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, fooddrink: 1, restaurant: 1, bestofaa: 1}
                    },
                    "pretzelbell":{
                        name: "Pretzel Bell",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, fooddrink: 1, restaurant: 1, bestofaa: 1}
                    },
                    "pricklypear":{
                        name: "Prickly Pear",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "isalita":{
                        name: "Isalita",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 2,
                        totalMisc: 2,
                        categories: {location: 1, fooddrink: 1, restaurant: 1, datespot: 1, bestofaa: 1}
                    },
                    "livebar":{
                        name: "LIVE",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, entertainment: 1, nightlife: 1}
                    },
                    "brownjug":{
                        name: "Brown Jug",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, entertainment: 1, nightlife: 1}
                    },
                    "redhawk":{
                        name: "Red Hawk Bar & Grill",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, entertainment: 1, nightlife: 1}
                    },
                    "vinbar":{
                        name: "Vin Bar",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, entertainment: 1, nightlife: 1}
                    },
                    "alleybar":{
                        name: "Alley Bar",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, entertainment: 1, nightlife: 1}
                    },
                    "mash":{
                        name: "Mash",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, entertainment: 1, nightlife: 1, bestofaa: 1}
                    },
                    "barlouie":{
                        name: "Bar Louie",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, entertainment: 1, nightlife: 1}
                    },
                    "ugli":{
                        name: "Shapiro Undergraduate Library",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 2,
                        totalCats: 2,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, academics: 1, universitybuilding: 1, library: 1, studyspot: 1}
                    },
                    "clementslibrary":{
                        name: "Clements Library",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 2,
                        totalCats: 2,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, academics: 1, universitybuilding: 1, library: 1}
                    },
                    "duderstadt":{
                        name: "Duderstadt Center (Dude)",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 2,
                        totalCats: 2,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, academics: 1, universitybuilding: 1, library: 1}
                    },
                    "burtontower":{
                        name: "Burton Tower",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, academics: 1, universitybuilding: 1}
                    },
                    "masonhall":{
                        name: "Mason Hall",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, academics: 1, universitybuilding: 1}
                    },
                    "danabuilding":{
                        name: "Dana Building",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, academics: 1, universitybuilding: 1}
                    },
                    "schoolofsocialwork":{
                        name: "School of Social Work",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, academics: 1, universitybuilding: 1}
                    },
                    "schoolofeducation":{
                        name: "School of Education",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, academics: 1, universitybuilding: 1, studyspot: 1}
                    },
                    "palmercommons":{
                        name: "Palmer Commons",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, academics: 1, universitybuilding: 1, studyspot: 1}
                    },
                    "chemistrybuilding":{
                        name: "Chemistry Building",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, academics: 1, universitybuilding: 1}
                    },
                    "easthall":{
                        name: "East Hall",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, academics: 1, universitybuilding: 1}
                    },
                    "weiserhall":{
                        name: "Weiser Hall",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, academics: 1, universitybuilding: 1}
                    },
                    "cclittlebuilding":{
                        name: "CC Little Building",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, academics: 1, universitybuilding: 1}
                    },
                    "dentalbuilding":{
                        name: "Dental Building",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, academics: 1, universitybuilding: 1}
                    },
                    "munger":{
                        name: "Munger Graduate Residences",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, housing: 1, dorm: 1, studyspot: 1}
                    },
                    "mlb":{
                        name: "Modern Languages Building (MLB)",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, academics: 1, universitybuilding: 1}
                    },
                    "league":{
                        name: "The League",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, academics: 1, universitybuilding: 1}
                    },
                    "michiganunion":{
                        name: "Michigan Union",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, academics: 1, universitybuilding: 1}
                    },
                    "rackham":{
                        name: "Rackham Graduate School",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, academics: 1, universitybuilding: 1}
                    },
                    "hillauditorium":{
                        name: "Hill Auditorium",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, entertainment: 1, livemusic: 1}
                    },
                    "blindpig":{
                        name: "Blind Pig",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, entertainment: 1, livemusic: 1, bestofaa: 1}
                    },
                    "powercenter":{
                        name: "Power Center for the Performing Arts",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, entertainment: 1, livemusic: 1}
                    },
                    "necto":{
                        name: "Necto Nightclub",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 2,
                        totalCats: 2,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, entertainment: 1, livemusic: 1, nightlife: 1}
                    },
                    "umma":{
                        name: "University of Michigan Museum of Art (UMMA)",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, academics: 1, universitybuilding: 1, studyspot: 1}
                    },
                    "angellhall":{
                        name: "Angell Hall",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, academics: 1, universitybuilding: 1}
                    },
                    "ross":{
                        name: "Ross School of Business",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, academics: 1, universitybuilding: 1, studyspot: 1}
                    },
                    "lawschool":{
                        name: "Law School",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 2,
                        totalMisc: 2,
                        categories: {location: 1, academics: 1, universitybuilding: 1, studyspot: 1, bestofaa: 1}
                    },
                    "michigandaily":{
                        name: "Student Publications Building",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, academics: 1, universitybuilding: 1}
                    },
                    "pierpont":{
                        name: "Pierpont Commons",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, academics: 1, universitybuilding: 1}
                    },
                    "dowbuilding":{
                        name: "Dow Engineering Building (DOW)",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, academics: 1, universitybuilding: 1}
                    },
                    "ggbrown":{
                        name: "GG Brown Laboratory (GGBL)",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, academics: 1, universitybuilding: 1}
                    },
                    "eecsbuilding":{
                        name: "Electrical & Computer Engineering Building (EECS)",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, academics: 1, universitybuilding: 1}
                    },
                    "chrysler":{
                        name: "Chrysler Center",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, academics: 1, universitybuilding: 1}
                    },
                    "musicschool":{
                        name: "School of Music, Theatre & Dance",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, academics: 1, universitybuilding: 1}
                    },
                    "stamps":{
                        name: "Penny W. Stamps School Of Art & Design",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, academics: 1, universitybuilding: 1}
                    },
                    "fxb":{
                        name: "Francois-Xavier Bagnoud Building (FXB)",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, academics: 1, universitybuilding: 1}
                    },
                    "westquad":{
                        name: "West Quad",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, housing: 1, dorm: 1, studyspot: 1}
                    },
                    "northwood3":{
                        name: "Northwood III",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, housing: 1, dorm: 1}
                    },
                    "hatcher":{
                        name: "Hatcher Graduate Library",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 2,
                        totalCats: 2,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, academics: 1, universitybuilding: 1, library: 1, studyspot: 1}
                    },
                    "northquad":{
                        name: "North Quad",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, housing: 1, dorm: 1, studyspot: 1}
                    },
                    "eastquad":{
                        name: "East Quad",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, housing: 1, dorm: 1, studyspot: 1}
                    },
                    "alicelloyd":{
                        name: "Alice Lloyd Hall",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, housing: 1, dorm: 1, studyspot: 1}
                    },
                    "markley":{
                        name: "Mary Markley Hall",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, housing: 1, dorm: 1}
                    },
                    "bursley":{
                        name: "Bursley Hall",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, housing: 1, dorm: 1}
                    },
                    "betsybarbour":{
                        name: "Betsy Barbour House",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, housing: 1, dorm: 1}
                    },
                    "helennewberry":{
                        name: "Helen Newberry Residence",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, housing: 1, dorm: 1}
                    },
                    "fletcherhall":{
                        name: "Fletcher Hall",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, housing: 1, dorm: 1}
                    },
                    "hendersonhouse":{
                        name: "Henderson House",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, housing: 1, dorm: 1}
                    },
                    "marthacook":{
                        name: "Martha Cook",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, housing: 1, dorm: 1}
                    },
                    "oxford":{
                        name: "Oxford Community Center",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, housing: 1, dorm: 1}
                    },
                    "baits":{
                        name: "Baits Houses",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, housing: 1, dorm: 1}
                    },
                    "mojo":{
                        name: "Mosher-Jordan Hall",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, housing: 1, dorm: 1, studyspot: 1}
                    },
                    "stockwell":{
                        name: "Stockwell Hall",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, housing: 1, dorm: 1, studyspot: 1}
                    },
                    "couzens":{
                        name: "Couzens Hall",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, housing: 1, dorm: 1, studyspot: 1}
                    },
                    "palmerfield":{
                        name: "Palmer Field",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 3,
                        totalCats: 3,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, recarea: 1, yogaspot: 1, studyspot: 1, pickupsports: 1, sunbathingspot: 1}
                    },
                    "arb":{
                        name: "The Arb",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 3,
                        totalCats: 3,
                        curMisc: 3,
                        totalMisc: 3,
                        categories: {location: 1, recarea: 1, yogaspot: 1, studyspot: 1, datespot: 1, pickupsports: 1, sunbathingspot: 1, bestofaa: 1}
                    },
                    "aum":{
                        name: "aUM Yoga",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, recarea: 1, yogaspot: 1, bestofaa: 1}
                    },
                    "bandemerpark":{
                        name: "Bandemer Park",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, recarea: 1, sunbathingspot: 1}
                    },
                    "elbelfield":{
                        name: "Elbel Field",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 3,
                        totalCats: 3,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, recarea: 1, yogaspot: 1, pickupsports: 1, sunbathingspot: 1}
                    },
                    "mitchellfield":{
                        name: "Mitchell Field",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 3,
                        totalCats: 3,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, recarea: 1, yogaspot: 1, pickupsports: 1, sunbathingspot: 1}
                    },
                    "michigantheater":{
                        name: "Michigan Theater",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 2,
                        totalCats: 2,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, entertainment: 1, movietheater: 1, datespot: 1, livemusic: 1}
                    },
                    "ark":{
                        name: "The Ark",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, entertainment: 1, livemusic: 1}
                    },
                    "statetheater":{
                        name: "State Theater",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, entertainment: 1, movietheater: 1}
                    },
                    "espressoroyalestate":{
                        name: "Espresso Royale (State St)",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, fooddrink: 1, coffeeshop: 1, studyspot: 1}
                    },
                    "sweeting":{
                        name: "Sweeting",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, dessert: 1}
                    },
                    "insomnia":{
                        name: "Insomnia Cookies",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, dessert: 1}
                    },
                    "cupcakestation":{
                        name: "Cupcake Station",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, dessert: 1}
                    },
                    "kilwins":{
                        name: "Kilwins",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, dessert: 1}
                    },
                    "blankslate":{
                        name: "Blank Slate Creamery",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 2,
                        totalMisc: 2,
                        categories: {location: 1, fooddrink: 1, dessert: 1, datespot: 1, bestofaa: 1}
                    },
                    "benandjerrys":{
                        name: "Ben and Jerry's",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, dessert: 1}
                    },
                    "stucchis":{
                        name: "Stucchi's",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, dessert: 1}
                    },
                    "washtenawdairy":{
                        name: "Washtenaw Dairy",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, fooddrink: 1, dessert: 1, bestofaa: 1}
                    },
                    "tropicalsmoothie":{
                        name: "Tropical Smoothie",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, dessert: 1}
                    },
                    "iorios":{
                        name: "Iorio's",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, fooddrink: 1, dessert: 1, bestofaa: 1}
                    },
                    "dolcevita":{
                        name: "La Dolce Vita",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, dessert: 1}
                    },
                    "ccrb":{
                        name: "Central Campus Recreational Building (CCRB)",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 2,
                        totalCats: 2,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, recarea: 1, fitnesscenter: 1, pickupsports: 1}
                    },
                    "imbuilding":{
                        name: "Intramural Sports Building (IM)",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 2,
                        totalCats: 2,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, recarea: 1, fitnesscenter: 1, pickupsports: 1, bestofaa: 1}
                    },
                    "ncrb":{
                        name: "North Campus Recreational Building (NCRB)",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 2,
                        totalCats: 2,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, recarea: 1, fitnesscenter: 1, pickupsports: 1}
                    },
                    "barrecode":{
                        name: "Barre Code",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, recarea: 1, fitnesscenter: 1}
                    },
                    "skeeps":{
                        name: "Scorekeepers (Skeeps)",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, entertainment: 1, nightlife: 1}
                    },
                    "hopcat":{
                        name: "Hopcat",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, entertainment: 1, nightlife: 1}
                    },
                    "diag":{
                        name: "The Diag",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 3,
                        totalCats: 3,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, recarea: 1, yogaspot: 1, pickupsports: 1, sunbathingspot: 1, studyspot: 1}
                    },
                    "lawquad":{
                        name: "Law Quad",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 3,
                        totalCats: 3,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, recarea: 1, yogaspot: 1, pickupsports: 1, sunbathingspot: 1, studyspot: 1}
                    },
                    "southquad":{
                        name: "South Quad",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, housing: 1, dorm: 1, studyspot: 1}
                    },
                    "charleys":{
                        name: "Charley's",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, entertainment: 1, nightlife: 1, bestofaa: 1}
                    },
                    "ashleys":{
                        name: "Ashley's",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, entertainment: 1, nightlife: 1, bestofaa: 1}
                    },
                    "dominicks":{
                        name: "Dominick's",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, entertainment: 1, nightlife: 1}
                    },
                    "autbar":{
                        name: "Aut Bar",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, entertainment: 1, nightlife: 1}
                    },
                    "bluelep":{
                        name: "Blue Leprechaun",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, entertainment: 1, nightlife: 1}
                    },
                    "ricks":{
                        name: "Rick's American Cafe",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, entertainment: 1, nightlife: 1, bestofaa: 1}
                    },
                    "tios":{
                        name: "Tio's Mexican Cafe",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "originalcottageinn":{
                        name: "Original Cottage Inn",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "cottageinntakeout":{
                        name: "Cottage Inn (Takeout)",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "afternoondelight":{
                        name: "Afternoon Delight",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "allenrumseysupperclub":{
                        name: "Allen Rumsey's Supper Club",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "amabistro":{
                        name: "Ama Bistro Family Restaurant",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "arborbrewingcompany":{
                        name: "Arbor Brewing Company",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "avalon":{
                        name: "Avalon Cafe and Kitchen",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "jamaicanjerkpit":{
                        name: "Jamaican Jerk Pit",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "jollypumpkin":{
                        name: "Jolly Pumpkin",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "jerusalemgarden":{
                        name: "Jerusalem Garden",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, fooddrink: 1, restaurant: 1, bestofaa: 1}
                    },
                    "knights":{
                        name: "Knight's",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "logan":{
                        name: "Logan an American Restaurant",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "lunchroom":{
                        name: "The Lunch Room",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, fooddrink: 1, restaurant: 1, bestofaa: 1}
                    },
                    "adventura":{
                        name: "Adventura",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        curMisc: 0,
                        totalCats: 1,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "quickieburger":{
                        name: "Quickie Burger",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "realseafoodcompany":{
                        name: "Real Seafood Company",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "ruthschris":{
                        name: "Ruth's Chris Steakhouse",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "sadako":{
                        name: "Sadako Japanese Restaurant",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, fooddrink: 1, restaurant: 1, bestofaa: 1}
                    },
                    "saladsup":{
                        name: "Salad's Up",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, fooddrink: 1, restaurant: 1, bestofaa: 1}
                    },
                    "savas":{
                        name: "Sava's",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 2,
                        totalMisc: 2,
                        categories: {location: 1, fooddrink: 1, restaurant: 1, datespot: 1, bestofaa: 1}
                    },
                    "shalimar":{
                        name: "Shalimar",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "silvios":{
                        name: "Silvio's",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "slurpingturtle":{
                        name: "Slurping Turtle",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "spencer":{
                        name: "Spencer",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "chophouse":{
                        name: "Chop House",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "earle":{
                        name: "The Earle",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "ravensclub":{
                        name: "The Raven's Club",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "tkwu":{
                        name: "TK WU",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, fooddrink: 1, restaurant: 1, bestofaa: 1}
                    },
                    "totoro":{
                        name: "Totoro",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "tomukun":{
                        name: "Tomukun",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, fooddrink: 1, restaurant: 1, bestofaa: 1}
                    },
                    "vinology":{
                        name: "Vinology",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "chinagate":{
                        name: "China Gate",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "zingermans":{
                        name: "Zingerman's Delicatessen",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, fooddrink: 1, restaurant: 1, bestofaa: 1}
                    },
                    "oldtowntavern":{
                        name: "Old Town Tavern",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "pitakabob":{
                        name: "Pita Kabob Grill",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, restaurant: 1}
                    },
                    "lab":{
                        name: "lab",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, coffeeshop: 1}
                    },
                    "roosroast":{
                        name: "RoosRoast",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, fooddrink: 1, coffeeshop: 1, bestofaa: 1}
                    },
                    "cometcoffee":{
                        name: "Comet Coffee",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, coffeeshop: 1}
                    },
                    "sweetwaterswashington":{
                        name: "Sweetwaters Coffee & Tea (Washington St)",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, coffeeshop: 1}
                    },
                    "sweetwatersliberty":{
                        name: "Sweetwaters Coffee & Tea (Liberty St)",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, coffeeshop: 1}
                    },
                    "commoncup":{
                        name: "Common Cup",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, coffeeshop: 1}
                    },
                    "literaticoffee":{
                        name: "Literati Coffee",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, fooddrink: 1, coffeeshop: 1, bestofaa: 1}
                    },
                    "espressoroyalesouthu":{
                        name: "Espresso Royale (South U)",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, coffeeshop: 1}
                    },
                    "mightygoodcoffee":{
                        name: "Mighty Good Coffee",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, coffeeshop: 1}
                    },
                    "elixirvitae":{
                        name: "Elixir Vitae Coffee and Tea",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, coffeeshop: 1}
                    },
                    "starbuckssouthu":{
                        name: "Starbucks (South U)",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, coffeeshop: 1}
                    },
                    "starbucksstate":{
                        name: "Starbucks (State St)",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, coffeeshop: 1}
                    },
                    "starbucksmain":{
                        name: "Starbucks (Main St)",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, fooddrink: 1, coffeeshop: 1}
                    },
                    "michiganstadium":{
                        name: "Michigan Stadium",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, misc: 1, athleticfacility: 1 }
                    },
                    "yosticearena":{
                        name: "Yost Ice Arena",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, misc: 1, athleticfacility: 1}
                    },
                    "crislercenter":{
                        name: "Crisler Center",
                        showInfo: false,

                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, misc: 1, athleticfacility: 1}
                    },
                    "canhamnatatorium":{
                        name: "Canham Natatorium",
                        showInfo: false,
                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, misc: 1, athleticfacility: 1}
                    },
                    "umgolfcourse":{
                        name: "UM Golf Course",
                        showInfo: false,
                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, misc: 1, athleticfacility: 1}
                    },
                    "varsitytenniscenter":{
                        name: "Varsity Tennis Center",
                        showInfo: false,
                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, misc: 1, athleticfacility: 1}
                    },
                    "cliffkeen":{
                        name: "Cliff Keen Arena",
                        showInfo: false,
                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, misc: 1, athleticfacility: 1}
                    },
                    "umindoortrack":{
                        name: "UM Indoor Track",
                        showInfo: false,
                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, misc: 1, athleticfacility: 1}
                    },
                    "ferryfield":{
                        name: "Ferry Field",
                        showInfo: false,
                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, misc: 1, athleticfacility: 1}
                    },
                    "alumnifield":{
                        name: "Alumni Field",
                        showInfo: false,
                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, misc: 1, athleticfacility: 1}
                    },
                    "rayfisherstadium":{
                        name: "Ray Fisher Stadium",
                        showInfo: false,
                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, misc: 1, athleticfacility: 1}
                    },
                    "phyllisockerfield":{
                        name: "Phyllis Ocker Field",
                        showInfo: false,
                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, misc: 1, athleticfacility: 1}
                    },
                    "soccerstadium":{
                        name: "UM Soccer Stadium",
                        showInfo: false,
                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, misc: 1, athleticfacility: 1}
                    },
                    "ragstock":{
                        name: "Ragstock",
                        showInfo: false,
                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, misc: 1, clothingstore: 1, bestofaa: 1}
                    },
                    "bivouac":{
                        name: "Bivouac",
                        showInfo: false,
                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, misc: 1, clothingstore: 1, bestofaa: 1}
                    },
                    "mden":{
                        name: "The M-Den",
                        showInfo: false,
                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 1,
                        totalMisc: 1,
                        categories: {location: 1, misc: 1, clothingstore: 1, bestofaa: 1}
                    },
                    "urbanoutfitters":{
                        name: "Urban Outfitters",
                        showInfo: false,
                        showTooltip: false,
                        isVisible: true,
                        curCats: 1,
                        totalCats: 1,
                        curMisc: 0,
                        totalMisc: 0,
                        categories: {location: 1, misc: 1, clothingstore: 1}
                    }
                }
            };

            this.changeCenter = this.changeCenter.bind(this);
            this.handleMarkerClick = this.handleMarkerClick.bind(this);
            this.handleMarkerClose = this.handleMarkerClose.bind(this);
            this.handleMarkerHover = this.handleMarkerHover.bind(this);
            this.handleMarkerMouseout = this.handleMarkerMouseout.bind(this);
            this.handleLocNavBar = this.handleLocNavBar.bind(this);
            this.setVisibility = this.setVisibility.bind(this);
            this.handleArticlesLoaded = this.handleArticlesLoaded.bind(this);
            this.hashChange = this.hashChange.bind(this);


        }

        handleLocNavBar() {
            if (document.getElementById("dropdown-content").style.display === "block") {
                document.getElementById("dropdown-content").style.display = "none";
            }
        }

        componentWillMount() {
            this.hashChange();
        }

        hashChange() {
            let hash = window.location.hash;
            if (hash === "#" || !hash) {

                switch (this.state.curPage) {
                    case "#":
                    case "":
                    break;
                    case "#search":
                    this.setState({
                        isSearch: false,
                        curPage: hash
                    });
                    break;
                    case "#filter":
                    this.setState({
                        isFilter: false,
                        curPage: hash
                    });
                    break;
                    case "#credits":
                    this.setState({
                        isCredits: false,
                        curPage: hash
                    });
                    break;
                    default:
                    const newMarkers = update(this.state.markers, {
                        [this.state.curPage]: {showInfo: {$set: false}}
                    });
                    this.setState({
                        markers: newMarkers,
                        curPage: hash,
                    });
                }
            }
            else if (hash === "#filter") {
                switch (this.state.curPage) {
                    case "#":
                    case "":
                    this.setState({
                        isFilter: true,
                        curPage: hash
                    });
                    break;
                    case "#filter":
                    break;
                    case "#credits":
                    this.setState({
                        isCredits: false,
                        isFilter: true,
                        curPage: hash
                    });
                    break;
                    case "#search":
                    this.setState({
                        isSearch: false,
                        isFilter: true,
                        curPage: hash
                    });
                    break;
                    default:
                    const newMarkers = update(this.state.markers, {
                        [this.state.curPage]: {showInfo: {$set: false}}
                    });
                    this.setState({
                        markers: newMarkers,
                        curPage: hash,
                        isFilter: true
                    });
                }
            }
            else if (hash === "#credits") {
                switch (this.state.curPage) {
                    case "#":
                    case "":
                    this.setState({
                        isCredits: true,
                        curPage: hash
                    });
                    break;
                    case "#filter":
                    this.setState({
                        isCredits: true,
                        isFilter: false,
                        curPage: hash
                    });
                    break;
                    case "#search":
                    this.setState({
                        isCredits: true,
                        isSearch: false,
                        curPage: hash
                    });
                    break;
                    case "#credits":
                    break;
                    default:
                    const newMarkers = update(this.state.markers, {
                        [this.state.curPage]: {showInfo: {$set: false}}
                    });
                    this.setState({
                        markers: newMarkers,
                        curPage: hash,
                        isCredits: true
                    });
                }
            }
            else if (hash === "#search") {
                switch (this.state.curPage) {
                    case "#":
                    case "":
                    this.setState({
                        isSearch: true,
                        curPage: hash
                    });
                    break;
                    case "#filter":
                    this.setState({
                        isSearch: true,
                        isFilter: false,
                        curPage: hash
                    });
                    break;
                    case "#credits":
                    this.setState({
                        isCredits: false,
                        isSearch: true,
                        curPage: hash
                    });
                    break;
                    case "#search":
                    break;
                    default:
                    const newMarkers = update(this.state.markers, {
                        [this.state.curPage]: {showInfo: {$set: false}}
                    });
                    this.setState({
                        markers: newMarkers,
                        curPage: hash,
                        isSearch: true
                    });
                }
            }
            else {
                hash = hash.split("#")[1];

                let jsonData = require('./json/' + hash + '.json');
                let lat = jsonData.position.lat;
                let lng = jsonData.position.lng;
                let newMarkers;

                this.changeCenter({lat: lat, lng: lng});

                switch (this.state.curPage) {
                    case "#":
                    case "":
                    newMarkers = update(this.state.markers, {
                        [hash]: {showInfo: {$set: true}},
                    });
                    this.setState({
                        markers: newMarkers,
                        curPage: hash
                    });
                    break;
                    case "#filter":
                    newMarkers = update(this.state.markers, {
                        [hash]: {showInfo: {$set: true}},
                    });
                    this.setState({
                        markers: newMarkers,
                        isFilter: false,
                        curPage: hash
                    });
                    break;
                    case "#credits":
                    newMarkers = update(this.state.markers, {
                        [hash]: {showInfo: {$set: true}},
                    });
                    this.setState({
                        markers: newMarkers,
                        isCredits: false,
                        curPage: hash
                    });
                    break;
                    case "#search":
                    newMarkers = update(this.state.markers, {
                        [hash]: {showInfo: {$set: true}},
                    });
                    this.setState({
                        markers: newMarkers,
                        isSearch: false,
                        curPage: hash
                    });
                    break;
                    default:
                    newMarkers = update(this.state.markers, {
                        [hash]: {showInfo: {$set: true}},
                        [this.state.curPage]: {showInfo: {$set: false}}
                    });
                    this.setState({
                        markers: newMarkers,
                        curPage: hash
                    });
                }
            }
        }

        componentDidMount() {
            window.addEventListener("hashchange", this.hashChange, false);
        }

        componentWillUnmount() {
            window.removeEventListener("hashchange", this.hashChange, false);
        }

        changeCenter(newCenter) {
            shouldPan = true;
            this.setState({
                center: newCenter,
                zoom: 16
            });
        }

        handleMarkerHover(targetMarker) {

            const newMarkers = update(this.state.markers, {
                [targetMarker]: {showTooltip: {$set: true}}
            });

            this.setState({
                markers: newMarkers,
            });
        }

        handleArticlesLoaded(newMarkers) {
            this.setState({
                markers: newMarkers,
            });
        }

        handleMarkerMouseout(targetMarker) {

            const newMarkers = update(this.state.markers, {
                [targetMarker]: {showTooltip: {$set: false}}
            });

            this.setState({
                markers: newMarkers,
            });
        }

        // Toggle to 'true' to show Modal and re-renders component
        handleMarkerClick(targetMarker) {
            if (document.getElementById("dropdown-content").style.display === "block") {
                document.getElementById("dropdown-content").style.display = "none";
            }
            window.location.hash = targetMarker;
        }

        // Toggle to 'false' to not display Modal and re-renders component
        handleMarkerClose(targetMarker) {
            window.location.hash = "";

            const newMarkers = update(this.state.markers, {
                [targetMarker]: {showInfo: {$set: false}}
            });

            this.setState({
                markers: newMarkers,
            });
        }

        // Toggle visibility and re-renders component
        setVisibility(newMarkers) {
            this.setState({
                markers: newMarkers,
            });
        }

        render() {
            return (
                <div style={{height: '100%'}}>
                    <InitialMap
                        containerElement={
                            <div style={{height: '100vh', width: 'auto'}} />
                        }
                        mapElement={
                            <div style={{height: '100vh', width: '100vw'}} />
                        }
                        changeCenter={this.changeCenter}
                        onMarkerClick={this.handleMarkerClick}
                        onMarkerClose={this.handleMarkerClose}
                        onMarkerHover={this.handleMarkerHover}
                        onMarkerMouseout={this.handleMarkerMouseout}
                        setVisibility={this.setVisibility}
                        closeLocNavBar={this.handleLocNavBar}
                        markers={this.state.markers}
                        center={this.state.center}
                        zoom={this.state.zoom}
                        isFilter={this.state.isFilter}
                        isCredits={this.state.isCredits}
                        isSearch={this.state.isSearch}
                        setArticlesLoaded={this.handleArticlesLoaded}
                    />
                </div>
            );
        }
    }



// WEBPACK FOOTER //
// ./src/Main.js